import { registerPlugin } from '@capacitor/core'
import type { StripeCheckoutPlugin } from './definitions'

const StripeCheckout = registerPlugin<StripeCheckoutPlugin>(
    'StripeCheckout',
    {
        web: () => import('./web').then(m => new m.StripeCheckoutWeb())
    }
)

export * from './definitions'
export { StripeCheckout }
